export default {
      id: "va-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#va",
      toString: function () {
        return this.url;
      }
    }